import { styled } from "@mui/material"

export const Image = styled("img")(() => ({}))
